<script lang="ts" setup>
import { computed, ref, onMounted, onUnmounted, nextTick, h, watch, defineCustomElement, onBeforeUnmount ,defineAsyncComponent} from 'vue';
import { Modal, Message } from 'winbox-ui-next';
window.$Modal = Modal;
import MarkdownIt from 'markdown-it';
import mermaid from "mermaid"
import resultSteps from '/@common/components/yy-message/components/stageSteps/index.vue';
// import markdownItCustomBlock from 'markdown-it-custom-block';
// import markdownItContainer from 'markdown-it-container';
import mdKatex from '@traptitech/markdown-it-katex';
import mila from 'markdown-it-link-attributes';
import mic from 'markdown-it-container';
// import customBlock from 'markdown-it-custom-block';
import hljs from 'highlight.js';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import { useSearchState } from '/@/stores/search';
import { useCopyCode } from '/@common/hooks/useCopyCode';
import mittBus from '/@common/utils/mitt';
import { useChatStore } from '/@/stores/chat';
import { useKnowledgeState } from '/@/stores/knowledge';
import { copyText } from '/@common/utils/format';
import { setScrollPosition } from '/@common/utils/other';
import { useRoute } from 'vue-router';
import { Session } from '/@common/utils/storage';
import { v4 as uuidv4 } from 'uuid';
import { getById } from '/@/api/knowledge';
const route = useRoute();
import loadingSvg from '/@common/assets/chat/loading.svg';
const { appId } = route.params as { appId: string };
import { ragTagSearchClick } from '/@common/utils/commonFunction';
import { addLastNodeClassToMarkdown } from './addLastNodeClassToMarkdown';
import { animatedPlugin } from './plugins/animated';
import SmilesDrawer from 'smiles-drawer';

import DSBridge from '/@common/utils/dsBridge/dsBridge'; 
import parseCard from "./components/fileParse/card.vue"
mermaid.initialize({ startOnLoad: false });

import anchor from 'markdown-it-anchor';
import toc from 'markdown-it-toc-done-right';

// 引入默认样式
// import 'highlight.js/scss/default.scss'
// 引入个性化的vs2015样式
// import 'highlight.js/styles/atom-one-dark.css';
// import 'highlight.js/styles/atom-one-light.css';
// import 'highlight.js/styles/base16/cupertino.css';
// import 'highlight.js/styles/github.css';
// import 'highlight.js/styles/base16/one-light.css';

import 'highlight.js/styles/github.css';
import { useI18n } from 'vue-i18n';
import { useRoleConfig } from '/@/stores/role';
import Search from './search.vue';
import Stages from './stages.vue';
import docDetail from './docDetail.vue';
import axios from 'axios';
const roleConfig = useRoleConfig();
const searchStore = useSearchState();
import { parseContent } from './parseContent';
// import hotIcon from './hot.svg';
const hotIcon =
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="50" height="50"><defs><linearGradient id="a" y2="100%" x2="50%" y1="0%" x1="50%"><stop offset="0%" stop-color="#FF9DAB"></stop><stop offset="100%" stop-color="#F54B5B"></stop></linearGradient></defs><g fill-rule="evenodd" fill="none"><path d="M0 0h18v18H0z"></path><path fill-rule="nonzero" fill="url(#a)" d="M12.269 4.77c.279 1.115-.249 2.404-1.241 3.008-.001-1.76-.189-3.43-1.22-4.829C9.24 2.184 8.37 1.52 7.523 1c.066 1.4.056 4.068-1.629 5.49C4.21 7.913 3 9.254 3 11.632c0 3.955 3.123 5.05 5.92 5.118 2.797.068 6.08-1.905 6.08-5.532 0-3.626-1.11-5.198-2.731-6.449Z"></path></g></svg>';
const hotkeyIcon =
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="50" height="50"><g fill-rule="evenodd" fill="none"><path d="M0 0h16v16H0z"></path><path fill="#355EFF" d="M11.712 2.355c-.174-.773-1.27-.768-1.436.006l-.019.086.435.094-.435-.094a2.357 2.357 0 0 1-1.882 1.837c-.796.14-.796 1.291 0 1.432a2.357 2.357 0 0 1 1.882 1.837l.019.086c.167.774 1.262.78 1.436.006l.022-.1a2.37 2.37 0 0 1 1.89-1.827c.798-.142.798-1.294 0-1.436a2.37 2.37 0 0 1-1.89-1.827l-.022-.1ZM7.987 3.573a.554.554 0 0 0-.43-.906h-.001a5.778 5.778 0 1 0 5.777 5.777.556.556 0 1 0-1.11 0 4.669 4.669 0 0 1-3.488 4.517 9.56 9.56 0 0 0 1.231-3.208.556.556 0 0 0-1.092-.206 8.44 8.44 0 0 1-1.313 3.185A7.665 7.665 0 0 1 6.229 9h2.565a.556.556 0 1 0 0-1.111H6.227c.114-1.517.7-3.013 1.76-4.316ZM5.114 7.889a8.695 8.695 0 0 1 1.265-3.962A4.671 4.671 0 0 0 2.922 7.89h2.192ZM2.922 9a4.671 4.671 0 0 0 3.466 3.964A8.717 8.717 0 0 1 5.115 9H2.922Z" data-follow-fill="#355EFF"></path></g></svg>';
const hotkeyIcon1 =
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="50" height="50"><g fill-rule="evenodd" fill="none"><path d="M0 0h16v16H0z"></path><path fill="#355EFF" d="M11.712 2.355c-.173-.773-1.27-.768-1.436.006l-.018.086.434.094-.434-.094a2.357 2.357 0 0 1-1.883 1.837c-.796.14-.796 1.291 0 1.432a2.357 2.357 0 0 1 1.883 1.837l.018.086c.167.774 1.263.78 1.436.006l.023-.1a2.37 2.37 0 0 1 1.889-1.827c.798-.142.798-1.294 0-1.436a2.37 2.37 0 0 1-1.89-1.827l-.022-.1ZM8.22 2.242a4.46 4.46 0 0 0-4.273 7.823v.972a.99.99 0 0 0 .99.99h2.602a.99.99 0 0 0 .99-.99v-.971c.387-.231.736-.519 1.036-.854a.556.556 0 0 0-.828-.74 3.332 3.332 0 0 1-1.01.765.556.556 0 0 0-.31.499v1.18H5.059v-1.18a.556.556 0 0 0-.309-.498 3.35 3.35 0 0 1 2.977-6 .556.556 0 0 0 .494-.996Zm-3.664 10.87a.556.556 0 1 0 0 1.11h3.333a.556.556 0 1 0 0-1.11H4.556Z" data-follow-fill="#355EFF"></path></g></svg>';
const hotkeyIcon2 =
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="50" height="50"><g fill-rule="evenodd" fill="none"><path d="M0 0h16v16H0z"></path><path fill="#355EFF" d="M11.712 2.355c-.174-.773-1.27-.768-1.436.006l-.019.086.435.094-.435-.094a2.357 2.357 0 0 1-1.882 1.837c-.796.14-.796 1.291 0 1.432a2.357 2.357 0 0 1 1.882 1.837l.019.086c.167.774 1.262.78 1.436.006l.022-.1a2.37 2.37 0 0 1 1.89-1.827c.798-.142.798-1.294 0-1.436a2.37 2.37 0 0 1-1.89-1.827l-.022-.1ZM7.987 3.573a.554.554 0 0 0-.43-.906h-.001a5.778 5.778 0 1 0 5.777 5.777.556.556 0 1 0-1.11 0 4.669 4.669 0 0 1-3.488 4.517 9.56 9.56 0 0 0 1.231-3.208.556.556 0 0 0-1.092-.206 8.44 8.44 0 0 1-1.313 3.185A7.665 7.665 0 0 1 6.229 9h2.565a.556.556 0 1 0 0-1.111H6.227c.114-1.517.7-3.013 1.76-4.316ZM5.114 7.889a8.695 8.695 0 0 1 1.265-3.962A4.671 4.671 0 0 0 2.922 7.89h2.192ZM2.922 9a4.671 4.671 0 0 0 3.466 3.964A8.717 8.717 0 0 1 5.115 9H2.922Z" data-follow-fill="#355EFF"></path></g></svg>';
interface Props {
	inversion?: boolean;
	id?: string;
	error?: boolean;
	text?: string;
	loading?: boolean;
	asRawText?: boolean;
	citations?: any;
	dialogueFileIds?: any;
	dialogueFolderIds?: any;
	paragraph?: string;
	skillId?: string;
	params?: any;
	isHighlightCode?: boolean;
	fileId?: any;
	fileUrl?: any;
	files?: any;
	fileName?: string;
	type?: string;
	resInfoState?: string;
	resInfos?: [];
	from?: string;
	modelVersion?: string;
	width?: number;
	index?: number;
	stages?: [];
	answerFinish?:boolean;
	source: string;
	messageAgent: string;
	callapseOrigin?: boolean
	searchEngineList?: [];
	searchEngineType?: number;
	answerType?: number;
	showStages?: boolean;
	roleName?: string;
	roleIcon?: string;
	round?: number;
	chatType?: number;
	uuid?: string;
	isLast?: boolean;
	gender?: string;
	age?: number;
	chatQuestion?:object
	roleId?:string
}

const props = defineProps<Props>();
const currentRole=ref({})
const emits = defineEmits(['update:isHighlightCode','updata:callapseOrigin']);
const chatStore = useChatStore();
const knowledgeState = useKnowledgeState();
const { isMobile } = useBasicLayout();
const { t } = useI18n();
const loadingWidth = ref(0);
const name=t('chat.center.nameYayi')
const downloadFile =  (url:string,name:string) => {
	axios.get(url, {responseType: 'blob'}).then((response) => {
		const blob = new Blob([response.data], { type: 'application/;charset=utf-8' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = name
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
	})
};
const showPreView=computed(()=>{
	return (!props?.inversion&&props?.files?.length==1&&!props?.loading&&roleConfig?.currentRole=='1658297003183144963')||(!props?.inversion&&props?.files?.length==1&&props?.from=='share'&&props?.roleId=='1658297003183144963')
})
const handleClick=(event)=>{
	if(DSBridge.isDSBridgeEnvironment()){
      // 检查点击的目标是否是 a 标签
      if (event.target.tagName === 'A') {
        // console.log('点击了链接:', event.target.href);
        // 在这里添加自定义逻辑
		event.preventDefault();
		DSBridge.callNative('getLinkUrl', { url: event.target.href });
      }
	}
}
const openLink=(item:object)=>{
	window.open(item.fileUrl, '_blank');
}
const getLoadingName=()=>{
	return localStorage.getItem('winbox-theme')?'cool-jiazai-hong': 'cool-jiazai2'
}
const clickItem=(e:any,item:any)=>{
	if (DSBridge.isDSBridgeEnvironment()) {
		DSBridge.callNative('triggerCitations', item)
		return 
	}
	e.preventDefault()
	let fileTypes=['txt','doc','docx','ppt','pptx','pdf','png','jpg','jpeg']
	if(fileTypes.includes(item.fileType.toLowerCase())){
		let data={
		url:item.fileUrl,
		type:item.fileType.toLowerCase(),
		name:item.fileName,
	}
	chatStore.previewFlag=true
	chatStore.previdewData=data
	}else{
		window.open(item.fileUrl, '_blank');
	}
}
let chatMode = computed(() => route.path.indexOf('chat') != -1 || route.path.indexOf('share'));
window.mouseOverHandler = (contentIndex: number, boxIndex: number) => {
	let contentBox = document.querySelectorAll('.markdown-body');
	let lists = contentBox[contentIndex];
	if (lists) {
		lists.querySelectorAll('.recommend-popup').forEach((list) => {
			list.style.display = 'none';
		});
		let lis = lists.querySelectorAll('.recommend-box');
		let item = lis[boxIndex - 1];
		if (item) {
			let dom = item.querySelector('.recommend-popup') as HTMLDivElement;
			dom.style.display = 'flex';
		}
	}
};
watch(() => roleConfig,
    (val) => {
      if (!val.roleConfig.length) return;
			currentRole.value = roleConfig.currentRoleInformation || {}
    },
    { immediate: true, deep: true }
)
const currentRoleNew = computed(() => {
	return roleConfig.currentRoleInformation
}
)
window.mouseOverLeaveHandler = (contentIndex: number, boxIndex: number) => {
	let contentBox = document.querySelectorAll('.markdown-body');
	let lists = contentBox[contentIndex];
	if (lists) {
		let lis = lists.querySelectorAll('.recommend-box');
		let item = lis[boxIndex - 1];
		if (item) {
			let dom = item.querySelector('.recommend-popup') as HTMLDivElement;
			dom.style.display = 'none';
			let first = lis[0].querySelector('.recommend-popup') as HTMLDivElement;
			first.style.display = 'flex';
		}
	}
};
window.setsendMessage = async (event,content: string, param: any, param_origin: any) => {
	if(DSBridge.isDSBridgeEnvironment()){
		event.preventDefault();
	}
	
	try {
		if (chatStore.dialogueLoading) return;
		if (((!route.params.conversationId || route.params.conversationId == '' || chatStore.isSensitive)&&(!props.from||props.from!='debug'))||(props.from=='debug'&&!chatStore.debugConversationId)) {
			chatStore.isSensitive = false;
			//await chatStore.addHistory({ appId: route.params.appId }, { name: text });
			await chatStore.addHistory({ appId: chatStore.bgRoleId,from:props?.from||'', appRoleId: roleConfig.currentRole }, { name: text });
		}
		if(DSBridge.isDSBridgeEnvironment()){
			DSBridge.callNative('reBuildChat')
		}
		
		const data = {
			appId,
			content,
			conversationId: route.params.conversationId,
			param: JSON.stringify({ ...param_origin, ...param }),
		};
		if(!data.appId){
			data.appId='21'
		}
		if(props.from=='debug'){
			data.conversationId=chatStore.debugConversationId

		}
		if (props.dialogueFileIds) {
			data.dialogueFileIds = props.dialogueFileIds;
		}
		if (props.dialogueFolderIds) {
			data.dialogueFolderIds = props.dialogueFolderIds;
		}
		if (props?.paragraph) {
			data.paragraph = props?.paragraph;
		}
		if (props?.skillId) {
			data.skillId = props?.skillId;
		}
		if(DSBridge.isDSBridgeEnvironment()){
			DSBridge.callNative('getDeepThinkStatus',(res)=>{//1开启 0:没有开启
			data.isDeepthink = res==1?true:false
		})
		}
		chatStore.setChatList(data);
	} catch (error) {}
};
useCopyCode();
const textRef = ref<HTMLElement>();

const mdMini = new MarkdownIt({
	html: true,
	linkify: false,
	highlight(code, language, attrs) {
		const validLang = !!(language && hljs.getLanguage(language));
		if (validLang) {
			const lang = language ?? '';
			return highlightBlock(hljs.highlight(code, { language: lang }).value, lang);
		}
		return highlightBlock(hljs.highlightAuto(code).value, '');
	},
});

const mdi = new MarkdownIt({
	html: true,
	linkify: false,
	highlight(code, language, attrs) {
		const validLang = !!(language && hljs.getLanguage(language));
		if (validLang) {
			const lang = language ?? '';
			return highlightBlock(hljs.highlight(code, { language: lang }).value, lang);
		}
		return highlightBlock(hljs.highlightAuto(code).value, '');
	},
});
// 配置锚点
mdi.use(anchor, {
	level: [1, 2, 3, 4, 5],
	permalink: anchor.permalink.ariaHidden({
		placement: 'before',
		class: 'header-anchor',
		symbol: '#',
		renderHref: (slug) => `#${slug}`,
		ariaHidden: true,
	}), // 在标题旁添加锚点链接
	slugify: (s) =>
		encodeURIComponent(String(s))
			.trim()
			.toLowerCase()
			.replace(/\s+/g, '-')
			.replace(/[^\w\-]+/g, '')
			.replace(/\d/g, ''),
});

// 配置目录生成
mdi.use(toc, {
	level: 1, // 包含的标题级别
	containerClass: 'markdown-toc',
	listType: 'ul',
	listClass: 'toc-list',
	itemClass: 'toc-item',
	linkClass: 'toc-link',
	markerPattern: /^\[toc\]$/im,
	format: (heading) => heading,
	slugify: (s) =>
		encodeURIComponent(String(s))
			.trim()
			.toLowerCase()
			.replace(/\s+/g, '-')
			.replace(/[^\w\-]+/g, '')
			.replace(/\d/g, ''),
	callback: (html, ast) => {
		emits('onChangeToc', processTocAst(html, ast));
	}, // 使用我们的 AST 处理器
});

// 修复 ** 紧邻标点符号时无法渲染加粗的问题
// markdown-it 的 flanking delimiter 规则对标点边界的判断会导致 can_open/can_close 失效
// 解决方案：render 前在 ** 和紧邻的标点字符之间插入零宽空格 \u200b
const fixCjkEmphasis = (text: string): string =>
	text.replace(/(\*{1,3})([\u0080-\uFFFF"'()[\]{}<>])/g, '$1\u200b$2').replace(/([\u0080-\uFFFF"'()[\]{}<>])(\*{1,3})/g, '$1\u200b$2');

// 处理 AST 并添加深度类
const processTocAst = (html, ast) => {
	// 创建一个虚拟 DOM 解析器
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');
	const navElement = doc.querySelector('nav');

	// 递归处理 AST 并添加深度类
	const processNodes = (node, parentElement, depth = 1) => {
		if (!node || !node.c) return;

		const ulElement = parentElement.querySelector('ul') || parentElement;

		node.c.forEach((childNode, index) => {
			const liElement = ulElement.children[index];
			if (!liElement) return;

			// 添加深度类
			liElement.classList.add(`toc-level-${depth}`);
			liElement.setAttribute('data-depth', depth);

			// 处理子节点
			if (childNode.c && childNode.c.length > 0) {
				processNodes(childNode, liElement, depth + 1);
			}
		});
	};
	// 从根节点开始处理
	processNodes(ast, navElement, 1);
	return navElement.outerHTML;
};
// 自定义的DOM标签渲染
// function codeResultPlugin(md) {
// 	console.log(md);

// 	// 自定义解析规则，检测 <code_result> 标签并捕获其内容
// 	md.inline.ruler.before('emphasis', 'code_result', (state, silent) => {
// 		const codeResultRegex = /<code_result>(.*?)<\/code_result>/g;
// 		const match = codeResultRegex.exec(state.src.slice(state.pos));
// 		if (match) {
// 			if (!silent) {
// 				const token = state.push('code_result', '', 0);
// 				token.content = match[1];
// 			}
// 			state.pos += match[0].length;
// 			return true;
// 		}
// 		return false;
// 	});

// 	// 自定义渲染规则，渲染 <code-result> 标签为所需的 HTML
// 	md.renderer.rules.code_result = (tokens, idx) => {
// 		const content = tokens[idx].content;
// 		// 再次调用 markdown-it 渲染器，解析嵌套的 Markdown 内容
// 		const renderedContent = md.renderInline(content);
// 		return `<div class="code-result">
// 				<div class="result-top"><p>结果</p></div>
// 	  			<div class="result-content">${renderedContent}</div>
// 		</div>`;
// 	};
// }

// 使用自定义插件
// mdi.use(codeResultPlugin);

mdi.use(mdKatex, { blockClass: 'katexmath-block rounded-md p-[10px]', errorColor: ' #cc0000' });
const recommendKey = [
	{ name: '热点摘要', key: '内容进行概述', type: 1, param: {}, icon: hotkeyIcon },
	{ name: '观点分析', key: '各方观点', type: 2, param: { get_news_num: 1 }, icon: hotkeyIcon1 },
	{ name: '生成报告', key: '生成报告', type: 3, param: { get_news_num: 1 }, icon: hotkeyIcon2 },
];
// 注册插件，并指定自定义容器的名称和渲染方式

// 注册插件，并指定自定义容器的名称和渲染方式
mdi.use(mic, 'r', {
	// 验证自定义容器是否符合规则
	validate: function (params) {
		return params.trim().match(/^r\s+(.*)$/);
	},
	// 渲染自定义容器的开头
	render: function (tokens, idx) {
		var m = tokens[idx].info.trim().match(/^r\s+(.*)$/);
		let listindex = 0;
		let listText = '';
		if (tokens[idx].nesting === 1) {
			const arr = m[1].split(',');
			let result = '';
			// 生成一个 10 到 999 之间的随机整数
			const random = Math.floor(Math.random() * (999 - 10 + 1)) + 10;
			if (arr[1]) {
				// result = '<span class="about">相关</span>';
				recommendKey.forEach((element, index) => {
					let text = arr[0].split('.')[1];
					let texttotal=arr[0]
					listText = text;
					listindex = arr[0].split('.')[0];
					// 找到第一个"."的位置
					const dotIndex = arr[0].indexOf('.');

					// 提取"."后面的内容
					if (dotIndex !== -1) {
						text = arr[0].substring(dotIndex + 1).trim(); // 使用trim()去除多余的空格
					}
					const key =
						element.type === 1
							? `请对 ${text} 的${element.key}，详细列举：`
							: element.type === 2
							? `关于 ${text} 的${element.key}，详细列举：`
							: `请以 ${text} 为题，写一个分析报告`;
					//const key = element.type === 1 ? `请对${text} 的${element.key}，详细列举：` : `关于${text} 的${element.key}，详细列举：`;
					result += `
								<button type="button"  onclick='setsendMessage(event,"${key}",${JSON.stringify(element.param)},${
						props.params
					})'  class="w-btn w-btn-outline recommend-item recommend-item-${index}">
					${element.icon}
					${element.name}
								</button>
							`;
				});
			}
			if (!chatMode.value) {
				const key = arr[0];
				const params = {};
				return `
					<div  class="recommend-title target-${idx * random} recommend-title-pointer" onclick='setsendMessage(event,"${key}",${JSON.stringify(params)},${
					props.params
				})'>
					${arr[0]}
					</div>
				`;
			} else {
				const hotStr = arr[1] ? `<xy-button  class="recommend-hot">${hotIcon}${arr[1]}</xy-button>` : ``;
				const index_ = arr[0].split('.')[0];
					// 找到第一个"."的位置
				const dotIndex = arr[0].indexOf('.');
					let text_ = ''
					// 提取"."后面的内容
					if (dotIndex !== -1) {
						text_ = arr[0].substring(dotIndex + 1).trim(); // 使用trim()去除多余的空格
					}
				// 返回一个带有标题和隐藏按钮的div元素
				return `
				<div class="recommend-box">
					<div  class="recommend-title target-${idx * random}">
					<span class="recommend-index recommend-index-${index_}">${index_}. </span>
					${text_}
					${hotStr}
					</div>
					<div class="recommend-popup recomend-${idx}" style="margin-bottom:3px"  target=".target-${idx * random}" type="custom" >
					
					${result}
					</div>
				</div>
					`;
			}
		} else {
			return '';
		}
	},
});

// mdi.use(addLastNodeClassToMarkdown);
// 自定义插件
const nullLinkPlugin = (md) => {
	const defaultRender = md.renderer.rules.link_open || ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));

	md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
		const token = tokens[idx];
		const hrefIndex = token.attrIndex('href');
		const targetIndex = token.attrIndex('target');
		// const hrefIndex = token.attrIndex('href');

		if (hrefIndex !== -1 && token.attrs[hrefIndex][1] === 'null') {
			// 将链接地址为 null 的 href 替换为 javascript:void(0)
			token.attrs[hrefIndex][1] = 'javascript:void(0)';
			token.attrs[targetIndex][1] = '';
		}

		return defaultRender(tokens, idx, options, env, self);
	};
};
mdi.use(nullLinkPlugin);
mdi.use(mila, { attrs: { target: '_blank', rel: 'noopener' } });

const wrapClass = computed(() => {
	return [
	props.loading?'markdownLoading':'',
		'min-w-[20px]',
		'text-box-' + appId,
		isMobile.value ? 'rounded-md' : 'px-4  rounded-2xl',
		props.inversion ? isMobile.value && props.text.trim() ? 'p-4' : '':isMobile.value && props.text ? 'p-4' : '',
		props.inversion ? props.text.trim() ? 'py-2' : '':props.text ? 'py-2' : '',
		props.inversion ? 'bg-[rgb(var(--primary-5))]' : 'bg-[rgba(255,255,255,0.7)]',
		props.inversion ? (isMobile.value ? ' ' : ' ') : isMobile.value ? ' ' : 'py-4 ',
		props.inversion ? 'dark:bg-[#a1dc95]' : 'dark:bg-[#1e1e20]',
		props.inversion ? 'message-request' : 'message-reply',
		props.inversion ? 'text-white' : 'text-wrap',
		{ 'text-red-500': props.error },
		props.inversion ? (props.type == 'img' ? 'isImgCss' : '') : props.type == 'img' ? '' : '',
		props.inversion ? 'text-message-request' : props.messageAgent === 'search' && props.stages && !chatStore.stopChat && !props.text ? 'text-message-reply-nopadding':'text-message-reply',
		props.messageAgent === 'search' ? 'w-full' : '',
	];
});
const isChat = computed(() => route.path.indexOf('chat') != -1 || props.from == 'share');
const maxHight = computed(() => {
	return [props.inversion ? (isChat.value ? '' : 'maxHeight260') : isChat.value ? '' : ''];
});
const handleImageLoad = (event) => {
	const dom = (document.querySelector('.center-side').scrollTop = 9999999);
};

const isMarkdownImg = ref([]);
const addLoadEventToImgTags = (htmlString) => {
	// setTimeout(() => {
	// 	setScrollPosition('.center-side');
	// }, 100);
	var regex = /(<img\s+[^>]*)(>)/g;
	var replacement = `$1  onclick="showPreviewImg(event)" $2`;
	if (appId == '20') {
		replacement = `$1  onclick="showPreviewImg(event)" onload="document.querySelector('.center-side').scrollTop = 999999999"$2`;
	}
	// var replacement = `$1  onclick="showPreviewImg(event)" onload="document.querySelector('.center-side').scrollTop = 999999999"$2`;
	// var replacement = `$1  onclick="showPreviewImg(event)" $2`;
	var newHtmlString = htmlString.replace(regex, replacement);
	return newHtmlString;
};
// 定义一个函数，接受一个对象作为参数，返回一个字符串
const textToMarkdown = (text: string, citations: any) => {
	// 判断json格式
	try {
		const jsonObj = JSON.parse(text); // 将字符串解析为一个对象
		const jsonFormatted = JSON.stringify(jsonObj, null, 2);
		text = '```json\n' + jsonFormatted + '\n```';
	} catch (error) {}

	// 截取:::r 结束的字符串
	if (text.endsWith('\n:')) {
		text = text.slice(0, -3);
	}
	if (text.endsWith('\n::')) {
		text = text.slice(0, -4);
	}
	if (text.endsWith('\n:::')) {
		text = text.slice(0, -5);
	}
	if (text.endsWith('\n:::r')) {
		text = text.slice(0, -6);
	}
	if (text.endsWith('\n:::r ')) {
		text = text.slice(0, -7);
	}

	// 初始化一个空字符串，用于存储结果
	let result = '';
	if (!citations) {
		return text;
	}
	// 是否包含图片
	var regexImage = /!\[.*?\]\(.*?\)/g;
	// isMarkdownImg.value = regexImage.test(text);
	isMarkdownImg.value = text.match(regexImage) || [];
	// 遍历对象的 res_info 属性，获取每个键值对
	return text
	//fix:处理没有返回a链接形式按照a链接格式拼接的问题 2025.4.17
	let citationsTemp: any = [];
	for (const key in citations) {
		// 获取当前键值对的值，即一个子对象
		const value = citations[key];
		const { no, fileUrl = '#' } = value;
		const fileName = value.fileName.replace(/'/g, "\\'").replace(/\n/g, ' ');
		// 将子对象的 title 和 context 属性拼接成 markdown 的链接引用格式，并添加到结果字符串中
		if (route.path.indexOf('chat') != -1 || props.from == 'share') {
			result += `[${no}]: ${fileUrl ? encodeURI(fileUrl) : null} \'${fileName}\'\n\n`;
			citationsTemp.push(no);
		} else {
			const { noSet = null } = value;
			if (noSet) {
				// noSet.forEach((element:number) => {
				// 	result += `[${element}]: ${fileUrl ? null : null} \'${fileName}\'\n\n`;
				// 	citationsTemp.push(element)
				// });
			} else {
				result += `[${no}]: ${fileUrl ? null : null} \'${fileName}\'\n\n`;
				citationsTemp.push(no);
			}
		}
	}
	// 在结果字符串末尾添加一个空行
	result += '\n';
	if (result != '\n') {
        result += '<p class="hidden"></p>\n\n';//fix:修改推流首个标题标签不渲染问题 加的两个\n 2025/3/12
    }
	// 将对象的 res 属性的值，即一个字符串，替换其中的数字为上标引用，并在每个数字后面加上一个空格，并添加到结果字符串中
	result += text.replace(/\[(\d+)\]/g, (match, p1) => {
		// 使用回调函数替换匹配的内容
		const num = Number(p1); // 将 $1 转换为数字
		// return `<a href="${res_info[num].title}">${res_info[num].context || ''}</a>`; // 返回对应的 context
		// return `[${num}]`; // 返回对应的 context
		if (citationsTemp.indexOf(num) >= 0) {
			// 判断是否存在此角标
			return `[${num}][${num}]`; // 返回对应的 context
		}
		return `[${num}]`; // 返回对应的 context
	});

	// 返回结果字符串
	return result;
};

const textToMarkdownChat = (text: string, citations: any) => {
	// 判断json格式
	try {
		const jsonObj = JSON.parse(text); // 将字符串解析为一个对象
		const jsonFormatted = JSON.stringify(jsonObj, null, 2);
		text = '```json\n' + jsonFormatted + '\n```';
	} catch (error) {}

	// 截取:::r 结束的字符串
	if (text.endsWith('\n:')) {
		text = text.slice(0, -3);
	}
	if (text.endsWith('\n::')) {
		text = text.slice(0, -4);
	}
	if (text.endsWith('\n:::')) {
		text = text.slice(0, -5);
	}
	if (text.endsWith('\n:::r')) {
		text = text.slice(0, -6);
	}
	if (text.endsWith('\n:::r ')) {
		text = text.slice(0, -7);
	}
	// 初始化一个空字符串，用于存储结果
	let result = '';
	if (!citations) {
		return text;
	}
	// 是否包含图片
	var regexImage = /!\[.*?\]\(.*?\)/g;
	// isMarkdownImg.value = regexImage.test(text);
	isMarkdownImg.value = text.match(regexImage) || [];
	// 遍历对象的 res_info 属性，获取每个键值对

	let citationsTemp: any = [];
	for (const i in citations) {
		// 获取当前键值对的值，即一个子对象
		for (const key in citations[i].resInfo) {
			const value = citations[i].resInfo[key];
			const { no, url = '#' } = value;
			const title = value.title.replace(/'/g, "\\'").replace(/\n/g, ' ');
			// 将子对象的 title 和 context 属性拼接成 markdown 的链接引用格式，并添加到结果字符串中
			if (route.path.indexOf('chat') != -1 || props.from == 'share') {
				result += `[${no}]: ${url ? encodeURI(url) : null} \'${title}\'\n\n`;
				citationsTemp.push(no);
			} else {
				const { noSet = null } = value;
				if (noSet) {
					// noSet.forEach((element:number) => {
					// 	result += `[${element}]: ${url ? null : null} \'${title}\'\n\n`;
					// 	citationsTemp.push(element)
					// });
				} else {
					result += `[${no}]: ${url ? null : null} \'${title}\'\n\n`;
					citationsTemp.push(no);
				}
			}
		}
	}

	// 在结果字符串末尾添加一个空行
	result += '\n';
	// 将对象的 res 属性的值，即一个字符串，替换其中的数字为上标引用，并在每个数字后面加上一个空格，并添加到结果字符串中
	result += text.replace(/\[(\d+)\]/g, (match, p1) => {
		// 使用回调函数替换匹配的内容
		const num = Number(p1); // 将 $1 转换为数字
		// return `<a href="${res_info[num].title}">${res_info[num].context || ''}</a>`; // 返回对应的 context
		// return `[${num}]`; // 返回对应的 context
		if (citationsTemp.indexOf(num) >= 0) {
			// 判断是否存在此角标
			return `[${num}][${num}]`; // 返回对应的 context
		}
		return `[${num}]`; // 返回对应的 context
	});

	// 返回结果字符串
	return result;
};

// 引用弹窗相关代码
let closeTimeout = null; // 关闭弹窗的定时器ID
let sourceEvent = null; // 当前事件源的引用
const popupRef = ref(null); // 引用弹窗元素
const sourceNo = ref(0); // 与引用相关的编号
const sourceIndex = ref(0); // 引用列表中的索引
const sourceData = ref({}); // 用于存储引用详情的数据对象
const isPopupVisible = ref(false); // 控制弹窗显示状态的布尔值
const popupPosition = ref({ top: 0, left: 0 }); // 弹窗的位置对象

// 函数：启动关闭弹窗的延迟
const hidePopup = () => {
	startCloseDelay();
};

// 函数：获取引用数据
const getCitationsData = (sourceId:any) => {
	for (const i in props.citations) {
		const { no } = props.citations[i];
		if (no == sourceId) {
			sourceData.value = props.citations[i];// 将匹配的引用数据存储在sourceData中
		}
	}
	
}

const keepPopupVisible = () => {
	isPopupVisible.value = true;
	clearTimeout(closeTimeout);// 清除关闭弹窗的定时器
};

const handleMouseClick = async (event) => {
	try {
		if (event.target.classList.contains('ragTagSearch')) { 
			const { id, no, index } = event.target.dataset
			await ragTagSearchClick(id, no, index,props.index)
		}
		console.log('鼠标点击触发', event.target.classList);
		if(event.target.classList.contains('ragTag')){
		sourceIndex.value = event.target.dataset.index;
		sourceNo.value = event.target.dataset.no;
		getCitationsData(sourceNo.value)// 获取对应的引用数据
		if (DSBridge.isDSBridgeEnvironment()) {
			const data = {
				sourceIndex: sourceIndex.value,
				...sourceData.value
			}
			DSBridge.callNative('triggerCitations', data)
			event.target.classList.remove('active')
			return 
		}
		}
	} catch (error) {
		console.log(error);
		
	}
	
	
}
const handleMouseEnter = async (event) => {
	console.log('鼠标进入事件触发', event.target.classList);
	if (DSBridge.isDSBridgeEnvironment()) {
		return
	}
	if (event.target.classList.contains('ragTag')) {
		if (sourceEvent) {
			sourceEvent.target.classList.remove('active');
		}
		event.target.classList.add('active'); // 添加活动状态样式
		
		sourceIndex.value = event.target.dataset.index;
		sourceNo.value = event.target.dataset.no;
		getCitationsData(sourceNo.value)// 获取对应的引用数据
		// if (DSBridge.isDSBridgeEnvironment()) {
		// 	const data = {
		// 		sourceIndex: sourceIndex.value,
		// 		...sourceData.value
		// 	}
		// 	DSBridge.callNative('triggerCitations', data)
		// 	event.target.classList.remove('active')
		// 	return 
		// }
		if (JSON.stringify(sourceData.value) === '{}') {
			return
		}
		isPopupVisible.value = true;
		
		// 等待弹框渲染完成
		await nextTick();

		const popupRectHeight = 260; // 弹窗的高度
		const popupRectWidth = 360; // 弹窗的高度
		const windowHeight = window.innerHeight; // 窗口的高度
		const windowWidth = window.innerWidth; // 窗口的高度
		const targetRect = event.target.getBoundingClientRect(); // 获取目标元素的位置和尺寸
		
		// 计算弹框应该显示的位置：目标元素的右下角
		popupPosition.value = {
			top: targetRect.bottom + window.scrollY, // 注意加上 window.scrollY 以处理滚动
			left: targetRect.right + window.scrollX, // 注意加上 window.scrollX 以处理滚动
		};
		// 如果弹框底部超出可视区域，则向上调整
		if (popupPosition.value.top + popupRectHeight > windowHeight + window.scrollY) {
			popupPosition.value.top = windowHeight + window.scrollY - popupRectHeight;
		}
		// 如果弹框右侧超出可视区域，则向左调整
		if (popupPosition.value.left + popupRectWidth > windowWidth + window.scrollX) {
			popupPosition.value.left = targetRect.left + window.scrollX - popupRectWidth;
      }
	  if(isMobile.value){
		popupPosition.value.left = 10
	  }

		clearTimeout(closeTimeout); // 防止在延迟期间重新显示时关闭弹框
	}
};
const startCloseDelay = () => {
	closeTimeout = setTimeout(() => {
		isPopupVisible.value = false;
				try {
			sourceEvent.target.classList.remove('active');// 移除状态样式
		}catch{ }
	}, 200);
};

const handleMouseLeave = (event) => {
	if (event.target.classList.contains('ragTag')) {
		sourceEvent = event;
		startCloseDelay();
	}
};
const handleScroll = () => {
 let elements= document.querySelector('.ragTag.active');
 if(elements){
	closeTimeout = setTimeout(() => {
		isPopupVisible.value = false;
				try {
					elements.classList.remove('active');// 移除状态样式
		}catch{ }
	}, 50);

 }
 
};
onMounted(() => {
	if (textRef.value) {
		// 绑定事件
		textRef.value.addEventListener('mouseenter', handleMouseEnter, true);
		textRef.value.addEventListener('mouseleave', handleMouseLeave, true);
		textRef.value.addEventListener('click', handleMouseClick, true);
	}
	if(isMobile.value){
		let centerDom= document.querySelector('.center-side') as HTMLDivElement
		centerDom?.addEventListener('scroll', handleScroll);
	}
	
});

onUnmounted(() => {
	if (textRef.value) {
		// 移除事件
		textRef.value.removeEventListener('mouseenter', handleMouseEnter, true);
		textRef.value.removeEventListener('mouseleave', handleMouseLeave, true);
		textRef.value.removeEventListener('click', handleMouseClick, true);
	}
	if(isMobile.value){
		let centerDom= document.querySelector('.center-side') as HTMLDivElement
		centerDom?.removeEventListener('scroll', handleScroll);
	}
});
function convertBracketsToCom(input: string): string {
	// 用于记录每个数字出现的次数
	const countMap: { [key: string]: number } = {};
    // 替换原始字符串中的匹配内容，并加入出现次数的下标
	return input.replace(/◹\[(\d+)(?:##(\d+))?\]◸/g, (match, p1, p2) => {
		// p1 是匹配到的数字
		let number = p1;
		// 获取当前数字的出现次数，并且将其下标化
		let index = countMap[number] ?? 0;
			countMap[number] = index + 1;
		if (p2) {
			// const parts = p1.split('##');
			number = p1
			index = p2
		} 

        return `<span class="${props.messageAgent === 'search' ? 'ragTagSearch' : 'ragTag'}" data-id="${props.id}" data-no="${number}" data-index="${index}"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="61" height="61"><path fill="#0071be" d="M11.997 5v3.336a3.517 3.517 0 0 1-.879 2.464 3.728 3.728 0 0 1-2.32 1.2v-1.44c.572-.189.962-.469 1.172-.84.211-.37.315-.824.315-1.362H8.798V5h3.2ZM7.2 5v3.336a3.502 3.502 0 0 1-1.903 3.26A3.733 3.733 0 0 1 4 12v-1.44c.571-.188.962-.468 1.171-.838.212-.371.316-.825.316-1.363H4V5h3.2Z" data-follow-fill="#9A99AA"></path></svg></span>`;
    });
}
const citationsFiles = computed(() => {
	let _citations = props.citations || []
	_citations = _citations.filter((m) => m.type == 'FILE');
	return _citations
})

function isCodeBlockClosed(str) {
    let stack = [];
    let i = 0;

    while (i <= str.length - 2) {
        if (str.substring(i, i + 3) === "```") {
            stack.push("```");
            i += 3;
        } else if (str.substring(i, i + 2) === "$$") {
            stack.push("$$");
            i += 2;
        } else if (str.substring(i, i + 3) === "$$$") {
            stack.push("$$$");
            i += 3;
        } else {
            i++;
        }
    }

    return stack.length % 2 === 0;
}
const processImgInfo=(text: string):string=>{
        // 正则表达式匹配Markdown中的图片
	  const regex = /!\[(.*?)\]\((.*?)\)/g;
	  const urlRegex = /^https:\/\//g
      let result = text;
      let match;
	  let counter = 1;
      // 遍历所有匹配的图片
      while ((match = regex.exec(text)) !== null) {
		if( match[2]&&urlRegex.test( match[2])){
			const id = `img-${props?.id}-${counter++}`;
			const altText = match[1]; // 图片说明
            const imageUrl = match[2]; // 图片链接
	        let dom=document.getElementById(`${id}`)
			console.log(imageUrl,"图片")
            // 将图片和说明插入到Markdown中
            if(dom){//解决再次加载图片抖动问题 针对已经渲染的图片 默认给高度
				result = result.replace(match[0],`<img src="${imageUrl}" class="markdownImg imgHeight" id="${id}" alt="${altText}"  onclick="previewMarkDownUrl(event)" onload="document.querySelector('.center-side').scrollTop = 999999999" ondragstart="preventmarkDownImageDrag(event)"/><div id="${imageUrl}Info" class="imgInfo">${altText}</div>`);
			}else{
				result = result.replace(match[0],` <img src="${imageUrl}" id="${id}" class="markdownImg"  alt="${altText}"  onclick="previewMarkDownUrl(event)" onload="onLoadImg(event)" ondragstart="preventmarkDownImageDrag(event)"/><div id="${imageUrl}Info" class="imgInfo">${altText}</div>`);
			} 
		 }else{
			result = result.replace( match[0],'')
		}
		}
       
	  return result

}
const text = computed(() => {
	const value = props.text ?? '';
	if (!props.asRawText) {
		if (chatMode.value) {
			let value = '';
			if (props.text) {
				value = handleChartView(props.text);
				value = convertBracketsToCom(value);
			}
			// if (chatStore.modelVersion == 'YAYI-V2.5-30B-8K' || props.modelVersion == 'YAYI-V2.5-30B-8K') {
			// 	value = value ? textToMarkdownChat(value, props.resInfos || props.citations) : '';
			// } else {
				value = value ? textToMarkdown(value, props.citations) : '';
			// }
			
			// 处理katex格式,将\[\]  \(\)  处理成 $$  $
			let replacedText = value.replace(/([^\\])\\\[\s*(.*?)\s*\\\]/g, '$1$$$$$2$$$$\n');
			replacedText = replacedText.replace(/\\\(\s*(.*?)\s*\\\)/g, '$$$1$');
			//img处理并添加图像说明
			replacedText=processImgInfo(replacedText)
			// 解析内容
			const parsedResult = parseContent(replacedText);
			
			parsedResult.forEach((item) => {
				if (item.type == 'text' && item.status != 'finish') {
					if (isCodeBlockClosed(item.content)) {
						if (!item.content.endsWith("```") && !item.content.endsWith("$$") && !item.content.endsWith("$$$")) {
							item.content += ` <i class="last-node"></i>`
						}
					}
				}
				// item.html = addLoadEventToImgTags(mdi.render(item.content));//不使用之前的图片预览逻辑
				item.html = mdi.render(item.content);
			});
			return parsedResult;

			// 使用正则表达式替换自定义标签,用于代码渲染及结果渲染 by公式运行 zhiyiwei
			// 		replacedText = replacedText
			// 		.replace(/<code_result>([\s\S]*?)<\/code_result>/g, (match, p1) => {
			// 			return `<div class="code-result"><div class="result-top"><p>结果</p></div><div class="result-content">${mdMini.render(p1.trim())}</div></div>\n`;
			// 		});
			// 		replacedText = replacedText
			// 		.replace(/<code>([\s\S]*?)<\/code>/g, (match, p1) => {
			// 			return `<div class="code-result ${isOpen.value?'':'hide'}"><div class="result-top"   onclick="window['${uniqueId}']()"><p>代码生成：已经完成</p></div><div class="result-content">${mdMini.render(p1.trim())}</div></div>\n`;
			// 		});
			// 		let startTag = '<code>';
			// 		let endTag = '</code>';

			// 		// 查找 <code> 标签的位置
			// 		let startIndex = replacedText.indexOf(startTag);

			// 		if (startIndex !== -1) {
			// 		// 查找 </code> 闭合标签的位置
			// 		let endIndex = replacedText.indexOf(endTag, startIndex + startTag.length);

			// 		// 如果找到闭合标签，则提取内容；否则提取到字符串末尾
			// 		let extractedContent = endIndex !== -1
			// 			? replacedText.substring(startIndex + startTag.length, endIndex)
			// 			: replacedText.substring(startIndex + startTag.length);

			// 			let newContent = ` ${isOpen.value}<div class="code-result ${isOpen.value?'':'hide'}" ><div class="result-top" onclick="window['${uniqueId}']()"><p>代码生成...</p></div><div class="result-content">${mdMini.render(extractedContent.trim())}</div></div>\n`
			// 			replacedText = endIndex !== -1
			// ? replacedText.substring(0, startIndex) + newContent + replacedText.substring(endIndex + endTag.length)
			// : replacedText.substring(0, startIndex) + newContent;

			// 		}

			let htmlStr = mdi.render(replacedText);
			// htmlStr = addLoadEventToImgTags(htmlStr);//不使用之前的图片预览逻辑
			return htmlStr;
		} else {
			const value = props.text ? textToMarkdown(props.text, props.citations) : '';

			// 处理katex格式,将\[\]  \(\)  处理成 $$  $
			let replacedText = value.replace(/([^\\])\\\[\s*(.*?)\s*\\\]/g, '$1$$$$$2$$$$\n');
			replacedText = replacedText.replace(/\\\(\s*(.*?)\s*\\\)/g, '$$$1$');
	        //img处理并添加图像说明
	        replacedText=processImgInfo(replacedText)
			let htmlStr = mdi.render(replacedText);
			// htmlStr = addLoadEventToImgTags(htmlStr); //不使用之前的图片预览逻辑
			return htmlStr;
		}
	}
	return value;
});
window.previewMarkDownUrl = (event:any) => {
	chatStore.previewFlag=true
	let defaultName=t('chat.center.img')
	chatStore.previdewData={url:event.target?.currentSrc,name:event.target?.alt||defaultName,type:'img'}
};

// let regex = /@([^@\s]+\.(pdf|docx|doc|txt))/g;
let regex = /@([^@]+\.(pdf|docx|doc|txt|md))/g;
const isContainFile = computed(() => {
	if (!text.value || !props.inversion || (props.dialogueFileIds.length == 0 && props.dialogueFolderIds.length == 0)) return '';
	const matches = text.value.match(regex);
	return matches?.length;
});

const containFile = ref();

watch(
	() => containFile.value,
	(val) => {
		if (val) {
			TextToHtml();
		}
	}
);

const asRawText = ref(props.inversion);
const fileJump = async (id: any) => {
	let res = await getById(id);
	if (res.code == 200 && res.data) {
		let data = res.data;
		data.fileId = data.id;
		pdfJump(data, {});
	}
};
const TextToHtml = async () => {
	let fileIds = props.dialogueFileIds;
	let val = text.value;
	let matches = val.match(regex) || [];
	let files = fileIds.map((i: any, index: number) => {
		return {
			id: i,
			name: matches[index],
		};
	});
	let num = 0;
	let uuid = await uuidv4();
	let textArr = val.replace(regex, uuid).split(uuid);
	for (let i = 0; i < textArr.length; i++) {
		let item: any = textArr[i];
		let span = document.createElement('span');
		if (!item.trim()) {
			let file = files[num];
			if (!file) {
				break;
			}
			span.innerHTML = file?.name;
			span.className = 'attribution-items-file';
			span.onclick = () => {
				fileJump(file?.id);
			};
			num++;
		} else {
			span.innerHTML = item;
		}
		containFile.value.append(span);
	}
};

function highlightBlock(str: string, lang?: string) {
	emits('update:isHighlightCode', true);
	let langStr = '';
	if (lang) {
		langStr = `<span class="code-block-header__lang">${lang}</span>`;
	}
	return `<pre class="code-block-wrapper"><div class="code-block-header">${langStr}<span class="code-block-header__copy" onclick="copyBtn()">${t(
		'chat.center.copyCode'
	)}</span><span class="code-block-header__theme" onclick="themeBtn()">${t(
		'chat.center.themeChange'
	)}</span></div><code class="hljs code-block-body ${lang}">${str}</code></pre>`;
}

const pdfJump = (citation: any, page: any) => {
	let currItem: any = {};
	citation.id = citation.fileId;
	citation.name = citation.fileName;
	currItem = citation;
	let active = citation.id;
	let params = {
		currItem,
		active,
		params: {
			page: page?.pageNo ? page.pageNo : 1,
			paragraphs: page?.paragraphs ? page.paragraphs : [],
		},
	};
	knowledgeState.setPreviewData(params);
};
window.preventmarkDownImageDrag = (event) => {
  event.preventDefault(); // 阻止默认行为
};
window.onLoadImg=(event)=>{
	event.target.classList.add('imgHeight')
	// event.target.id=`${event.target.src}`
	window.document.querySelector('.center-side').scrollTop = 999999999
}
// 当界面挂载出来后就会自动执行
onMounted(() => {
// 	//流程图设置样式
// 	mermaid.initialize({
//     theme:'default',
//     startOnLoad: false, // 必须禁用自动初始化
//     themeVariables: {
//       primaryColor: '#FFD700', // 自定义颜色
//       edgeLabelBackground: '#FFF8E1',
//       fontSize: '16px'
//     },
//     flowchart: {
//       curve: 'basis' // 连接线样式
//     }
//   });
	changeLoadingWidth();
	window.addEventListener('resize', changeLoadingWidth);
});

// 页面卸载时
onUnmounted(() => {
	window.removeEventListener('resize', changeLoadingWidth);
});
defineExpose({ textRef });

const changeLoadingWidth = () => {
	if (!props.from) {
		let offsetWidth = document.getElementsByClassName('container-center')[0].offsetWidth;
		loadingWidth.value = offsetWidth - 160;
	}
};
const truncate = (str: string, limit: number) => {
	return str.length > limit ? str.slice(0, limit - 1) + '...' : str;
};

const optimizeCitations = (citations: any[]) => {
	const obj = {};
	citations.forEach((item) => {
		if (item.fileId in obj) {
			obj[item.fileId] = {
				...obj[item.fileId],
				pages: [...obj[item.fileId].pages, ...item.pages],
			};
		} else {
			obj[item.fileId] = item;
		}
	});
	return Object.keys(obj).reduce((arr, i) => [...arr, obj[i]], []);
};
const changeCollapse=()=>{
	emits('update:callapseOrigin', !props.callapseOrigin);
}
const textRander = {
	render: () => {
		return h('p', {});
	},
};
const isD2 = computed(() => {
	return window.location.host == 'llm.d2-ai.com';
});

import Chart from '/@common/components/yy-message/components/chartView/Chart.vue';
import longWriter from '/@common/components/yy-message/components/longWriter/longWriter.vue';
import longTask from '/@common/components/yy-message/components/longWriter/longTask.vue';
import formInput from '/@common/components/yy-message/components/formInput/index.vue';
const tableView = defineAsyncComponent(() => import('./components/tableView.vue'));
const sqlView = defineAsyncComponent(() => import('./components/sqlView.vue'));
const isChartView = ref(false);
const chartViewContent = ref<any>({});
const chartViewActiveKey = ref('');
const chartViewSql = ref('');
const chartViewData = ref([]);
const chartViewType = ref('');
const handleChartView = (text = '') => {
  // 将props.text中的<chart-view></chart-view>部分提取出来
  let chartView = '';
  if (text) {
    const chartViewReg = /<chart-view[^>]*\/>/g;
    const chartViewMatch = text.match(chartViewReg);
    if (chartViewMatch && chartViewMatch.length) {
      chartView = chartViewMatch[0];
      text = text.replace(chartView, '');
    }
  }
  isChartView.value = !!chartView;
  if (isChartView.value) {
    // 对chartView进行转义，并提取chart-view里content的值

    const regex = /content=['"]([^'"]*)['"]/;
    const match = chartView.match(regex);
    if (match) {
      const content = match[1];
      try {
        chartViewContent.value = JSON.parse(content.replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'));

        const { type, sql, data } = chartViewContent.value;

        if (!type) {
          isChartView.value = false;
          chartViewContent.value = {};
          return text;
        }
        if (type === 'response_table') {
          chartViewActiveKey.value = 'data';
        } else {
          chartViewActiveKey.value = 'chart';
        }
        chartViewSql.value = sql;
        chartViewData.value = data;
        chartViewType.value = type;
      } catch (error) {
        chartViewContent.value = {};
        isChartView.value = false;
        return text;
      }
    }
  }
  return text;
}
const getWidth = computed(() => {
	if (isMobile.value) {
		return 'calc(100vw - 52px)';
	} else {
		if (props.from == 'share') {
			return '100%'
		}
		if (props.messageAgent == 'search') {
			return '750px'
		}
		return props.from ? `${props.width}px` : `${chatStore.centerMaxWidth - 154}px`;
	}
});
</script>

<template>
	<div>
	<div class="text-black" :class="wrapClass">
		<transition name="fade">
			<doc-detail
				ref="popupRef"
				@mouseenter="keepPopupVisible"
				@mouseleave="hidePopup"
				v-if="isPopupVisible"
				:sourceIndex="sourceIndex"
				:sourceNo="sourceNo"
				:sourceData="sourceData"
				:style="{ top: `${popupPosition.top}px`, left: `${popupPosition.left}px` }"
			></doc-detail>
		</transition>
		<div ref="textRef" class="leading-relaxed break-words" :class="maxHight">
			<!-- 知识库 -->
			<div v-if="!inversion">
				<transition enter-active-class="" leave-active-class="animate__animated animate__faster animate__fadeOut absolute">
					<resultSteps  v-if=" !text.length && loading && messageAgent === 'search'" :stages="stages" :searchEngineType="searchEngineType" :searchEngineList="searchEngineList" :id="id"></resultSteps>
				</transition>
				<Stages :searchEngineType="searchEngineType" v-if="showStages&&stages&&stages.length&&answerType==0&&!chatStore.stopChat && (messageAgent != 'search' || (messageAgent == 'search' &&text.length))" :searchEngineList="searchEngineList" :messageAgent="messageAgent" :from="from" :text="text" :stages="stages" :source="source" :answerFinish="answerFinish" :roleIcon="roleIcon" :roleName="roleName" :loading="loading" :width="width" :modelVersion="modelVersion"></Stages>
				<Search :resInfoState="resInfoState" :resInfos="resInfos" :loading="loading" :from="from" :width="width"></Search>
				<template v-if="!asRawText">
					<div
						v-if="typeof text === 'string'"
						class="markdown-body"
						:class="['markdown-body-as-img-' + isMarkdownImg.length, chatStore.isLightTheme ? 'hljs-atom-one-light' : 'hljs-atom-one-dark',isMobile?'markdownMobile':'']"
						v-html="text"
					/>
					<div v-else class="code-box"  :style="{ maxWidth: getWidth }">
						<template v-for="(item, index) in text" :key="index">
							<template v-if="item.type === 'text'" >
								<div
									class="markdown-body output-text"
									:class="['markdown-body-as-img-' + isMarkdownImg.length, chatStore.isLightTheme ? 'hljs-atom-one-light' : 'hljs-atom-one-dark',isMobile?'markdownMobile':'']"
									v-html="item.html"
									@click="handleClick"
								/>
							</template>
							<template v-if="item.type === 'task'">
								<longTask :dialogueId="id" :loading="loading" :source="source" :attrData="item.attributes" :from="from"></longTask>
							</template>
							<template v-if="item.type === 'inputGroup'">
								<formInput :dialogueId="id" :gender="gender" :age="age" :index="props?.index" :isLast="isLast" :items="item.items" :from="from"  :round="round" :chatType="chatType" :uuid="uuid"></formInput>
							</template>
							<div class="search-text" v-if="item.type === 'code'">
								<w-collapse :style="{'padding-bottom': item.attributes.module == 'deepthink'?'':'12px' }" :default-active-key="['outline', 'deepthink']" class="collapseBox" :expand-icon-position="'right'" :bordered="false" expand-icon-position="left">
									<w-collapse-item :key="item.attributes.module">
										<template #header>
											<div class="mathTitle fontFam" v-if="item.status === 'finish' || !loading">
												<template v-if="item.attributes.module == 'outline'">
													<CoolChangwen color="var(--active-color)" size="14" class="icon-chazhao" />
													<span class="source">{{ source }}</span>
													{{ t('chat.center.outlineInfo') }}
												</template>
												<template v-else-if="item.attributes.module == 'deepthink'">
													<CoolJiazaiwancheng color="var(--active-color)" size="16" class="icon-chazhao" />
													<span class="source">{{currentRoleNew?.roleName || ''}}</span>
													{{ t('chat.center.deepthinkInfo') }}
												</template>
												<template v-else>
													<CoolShuxuefenxiF52jp5g0 color="var(--active-color)" size="14" class="icon-chazhao" />
													<span class="source">{{ source }}</span>
													{{ t('chat.center.resultInfo') }}
												</template>
											</div>
											<div v-else class="loading-icon">
												<!-- <SvgIcon :name="getLoadingName()" size="16" class="loading-img"/> -->
												<img :src="loadingSvg" class="loading-img loadImg" />
												<template v-if="item.attributes.module == 'outline'">{{ t('chat.center.outlineIng') }}</template>
												<template v-else-if="item.attributes.module == 'deepthink'"><span class="source" style="margin-right: 4px;">{{currentRoleNew?.roleName || ''}}</span>
													{{ t('chat.center.deepthinkIng') }}</template>
												<template v-else>{{ t('chat.center.resultIng') }}</template>
												<span class="dot-aniNew"></span>
											</div>
										</template>
										<template #expand-icon="{ active }">
											<w-popover placement="rt" trigger="hover" :show-arrow="false" content-class="rounded-lg border-none p-0 w-50 arrowIcon">
												<SvgIcon v-if="active" class="arricon" name="cool-ArrowUpSLineWe" size="14" color="#646479" />
												<SvgIcon v-else class="arricon" :name="`cool-ArrowDownSLineWe`" size="14" color="#646479" />
												<template #content>
													{{ !active ? $t('chat.role.arrow1') : $t('chat.role.arrow2') }}
												</template>
											</w-popover>
										</template>
										<div class="online">
											<template v-if="item.attributes.module == 'outline'">
												<div class="outline-box" >
													<longWriter :dataList=" JSON.parse(item.content) || []"></longWriter>
												</div>
											</template>
											<template v-else-if="item.attributes.module == 'deepthink'">
												<div
												class="markdown-body markdown-deepthink"
												:class="[
													'markdown-body-as-img-' + isMarkdownImg.length,
													chatStore.isLightTheme ? 'hljs-atom-one-light' : 'hljs-atom-one-dark',
												]"
												v-html="item.html"
											/>
											</template>
											<div
												v-else
												class="markdown-body"
												:class="[
													'markdown-body-as-img-' + isMarkdownImg.length,
													chatStore.isLightTheme ? 'hljs-atom-one-light' : 'hljs-atom-one-dark',
												]"
												v-html="item.html"
											/>
										</div>
									</w-collapse-item>
								</w-collapse>
							</div>
							<template v-if="item.type === 'code_result'">
								<div class="code-result">
									<div class="result-top">
										<p>{{ t('chat.center.result') }}</p>
									</div>
									<div class="result-content">
										<div
											class="markdown-body"
											:class="['markdown-body-as-img-' + isMarkdownImg.length, chatStore.isLightTheme ? 'hljs-atom-one-light' : 'hljs-atom-one-dark']"
											v-html="item.html"
										/>
									</div>
								</div>
							</template>
						</template>
					</div>
					<!-- <span class="loading_icon"></span> -->
				</template>

				<div v-else class="whitespace-pre-wrap" v-text="text" />
				<!-- ai搜索分享的来源 -->
				<div class="origin" v-if="route.params.type=='aiSearchs'&&props.citations?.length">
					<div class="title" v-if="!props.callapseOrigin" @click="changeCollapse">{{$t('chat.center.referenceSources')}} <CoolShouqi  size="16" color="#646479"/></div>
					<div class="originBox" v-else>
					  <div class="title" @click="changeCollapse">{{$t('chat.center.referenceSources')}} <CoolShouqi class="icon"  size="16" color="#646479"/></div>
						<div class="origin-list" v-for="(item,key) in props.citations" @click="openLink(item)">
							<div class="top">
								<div class="index">{{ item.no }}</div>
								<div class="title">{{ item.fileName }}</div>
							</div>
							<div class="middle">
								<span class="content">{{ item.context }}</span>
							</div>
							<div class="bottom">
								<img :src="item.fileIcon" alt="" v-if="item.fileIcon">
								<span class="source" v-if="item.fileSource">{{ item.fileSource }}</span>
								<span class="time" v-if="item.time">{{ item.time }}</span>
							</div>
						</div>
					</div>
				</div>
				
				<!-- execl 渲染 -->
				<div v-if="isChartView" class="text-chart-view !pt-0">
					<w-tabs :default-active-key="chartViewActiveKey" >
						<w-tab-pane key="chart" title="Chart" v-if="chartViewActiveKey === 'chart'">
						<Chart :data="chartViewData" :type="chartViewType" :style="{height: '340px' }"></Chart>
						</w-tab-pane>
						<w-tab-pane key="sql" title="SQL">
						<sqlView :data="chartViewSql" />
						</w-tab-pane>
						<w-tab-pane key="data" title="Data">
						<tableView :data="chartViewData" />
						</w-tab-pane>
					</w-tabs>
				</div>
			</div>
			<div v-if="inversion && paragraph" class="whitespace-annex-box">
				<span v-if="paragraph">{{ paragraph }}</span>
			</div>
			<div v-if="inversion && !isContainFile" :class="text.trim() != '' ? 'whitespace-pre-wrap' : ''" style="word-break: break-word;font-family: MiSansRegular;" v-safe-html="text" />

			<div v-if="isContainFile" class="whitespace-pre-wrap" :class="inversion && (paragraph || fileUrl) ? 'textBorder' : ''" ref="containFile" />
			<template v-if="(!text || text.length === 0) && !inversion && !resInfoState&&stages.length === 0&& messageAgent != 'search'">
				<!-- <span class="dark:text-white w-[2px] h-[20px] block animate-blink" /> -->
				<div
				class="loading-message"
					:style="{ width: !from&&!isMobile ? loadingWidth + 'px' : '100%'}"
				>
					<!-- <img :src="loadingSvg" class="loading-img" /> -->
					<template v-if="answerType == 3">
						{{ $t('chat.center.answerNodata1')}}{{ $t('chat.center.answerNodata2')}}{{$t('chat.center.answerNodata3')}}{{$t('chat.center.answerNodata4')}}{{$t('chat.center.answerNodata5')}}。 
					</template>
					 <template v-else>
						<SvgIcon :name="getLoadingName()" size="16" class="loading-img"/>
						<span class="fontFam " v-if="from=='debug'">{{ isD2 ? $t('chat.center.generateAnswerHK') : $t('chat.center.generateAnswer',{name:props.roleName}) }}</span>
						<span class="fontFam " v-else>{{ isD2 ? $t('chat.center.generateAnswerHK') : $t('chat.center.generateAnswer',{name:currentRoleNew?.roleName||name}) }}</span>
					 </template>
				</div>
			</template>
		</div>
		<!-- 来源 -->
		<div v-if="!inversion && citationsFiles.length && !loading && (route.path.indexOf('aiSearch') === -1||route.path.indexOf('aiSearch')>-1&&from=='debug')" class="content footer pt-2 flex items-start">
			<div class="learn-more">{{ $t('chat.center.refer') }}</div>
			<div class="attribution-container">
				<!-- <div class="attribution-items-link" v-if="route.path.indexOf('chat') != -1 || from == 'share'||route.path.indexOf('aiSearch') != -1"> -->
					<div class="attribution-items-link">
					<!-- <span 	
					  class="attribution-item-link pl-1 pr-1 cla"
						:target="item.fileUrl ? '_blank' : ''"
						v-for="item in citationsFiles"
						:key="item">{{ item.fileName }}</span> -->
					<a
						class="attribution-item-link pl-1 pr-1"
						:target="item.fileUrl ? '_blank' : ''"
						v-for="item in citationsFiles"
						:key="item"
						@click="clickItem($event,item)"
						:title="item.fileUrl || item.context"
						v-show="item.fileName"
					>
						{{ truncate(`${item.no}.${item.fileName}`, 40) }}
					</a>
				</div>
				<!-- <div class="attribution-items" v-else>
					<div class="attribution-items" v-for="item in optimizeCitations(citations)" :key="item">
						<span class="attribution-item px-1 pdfLink" @click="pdfJump(item, null)">
							<span>
								<CoolDocx class="fileIcon" v-if="['doc', 'docx'].includes(item.docType)" size="20" />
								<CoolPdf class="fileIcon" v-if="item.docType == 'pdf'" size="20" />
								<CoolTxt class="fileIcon" v-if="item.docType == 'txt'" size="20" />
								<CoolMarkdownB50n94pc class="fileIcon" v-if="item.docType == 'md'" size="20" />
							</span>
							<span>
								{{
									item.fileName.length > 21
										? item.fileName.slice(0, 16) + '...' + item.fileName.slice(item.fileName.length - 5, item.fileName.length)
										: item.fileName
								}}
							</span>
						</span>
						<span class="attribution-item px-1 spanLink" v-for="p in item.pages" :key="p" @click="pdfJump(item, p)">
							{{ truncate(`第${p.pageNo}页`, 40) }}
						</span>
					</div>
				</div> -->
			</div>
		</div>
		<slot name="footer"></slot>
		<slot name="question"></slot>
	</div>
	<slot name="longWriter"></slot>
	<!-- 政企文档解析 -->
	<parseCard v-if="showPreView"  :id="props?.id"></parseCard>
</div>
</template>

<style scoped lang="scss">

.code-box {
	.search-text {
		// padding-bottom: 12px;
		.online {
			padding: 0 8px 12px;
		}
		.collapseBox {
			font-family: MiSansRegular;
			:deep(.w-collapse-item-header) {
				left: 0;
				width: max-content;
			}
			:deep(.w-collapse-item-content) {
				background: var(--stages-bg);
				padding: 0 14px;
			}
			:deep(.w-collapse-item-content-box) {
				padding: 0;
			}
			:deep(.w-collapse-item-header-title) {
				margin-left: 9px;
				font-weight:400;
				font-family: MiSansRegular;
			}
			:deep(.w-collapse-item-active) {
				.w-collapse-item-header {
					border-radius: 8px 8px 0 0;
					width: auto;
				}
			}
			.icon-chazhao {
				// margin-right: 5px;
			}
			.mathTitle{
				color: #181b49;
				font-weight:400px;
				font-family: MiSansRegular;
			}
			.loadImg{
				width: 16px;
				height: 16px;
			}
			.loading-icon{
				display: flex;
				align-items: center;
			}
			.source {
				font-family: MiSansMedium;
				font-weight: 500;
                color: #181b49;
			}
			// .loading-img {
			// 	margin-right: 5px;
			// }
		}
	}
}
.origin{
		.title{
			display:flex;
			align-items: center;
			font-size: var(--font14);
      color: #646479;
			cursor:pointer;
		}
	}
.originBox{
  padding:12px 8px;
	background:rgba(244, 246, 249, .6);
	border-radius: 8px;
	.title{
			display:flex;
			align-items: center;
			font-size: var(--font14);
      color: #646479;
			cursor:pointer;	
			.icon{
			transform: rotate(-90deg);
			}
		}
		.origin-list{
			width: 100%;
			padding:6px 12px;
      // background: rgba(102,0,255,0);
      border-radius: 8px;
			cursor: pointer;
			.top{
				display:flex;
				align-items: center;	
				.index{
					background: #E4E8EE;
					padding:0 6px;
                    height: 16px;
                    line-height: 16px;
					border-radius:60px;
					font-size: var(--font12);
                    color: #181B49;
				}
				.title{
					max-width:98%;
					margin-left:4px;
					font-size: 14px;
                    color: #181B49;
					margin-top:3px;
					display: block;
					overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
				}

			}
			.middle{
				.content{
					font-size: var(--font14);
                    color: #646479;
					line-height: 22px;
					width:100%;
					overflow: hidden;
	                word-break: break-all;
	                text-overflow: ellipsis;
	                display: -webkit-box;
	                -webkit-line-clamp:2;
	                -webkit-box-orient: vertical;
				}
			}
			.bottom{
				display: flex;
				align-items: center;
				img{
					width:16px;
					height:16px;
				}
				.source{
					font-size: 12px;
                    color: #9A99AA;
					padding:0 4px;
				}
				.time{
					font-size: 11px;
                    color: #9A99AA;
				}
			}
			&:hover{
				background-color:#fff;
				box-shadow: 0px 6px 20px 0px rgba(30,64,175,0.06);
			}
		}
}
.text-chart-view{
	width: 200px;
	height: 200px;
}
</style>

<style lang="scss">
@import './style.scss';
.markdownLoading .code-box .output-text:last-child .last-node:after{
	content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
	background-image: url('/@common/assets/chat/loading_yayi.png');
    background-position: top;
    background-size: contain;
    position: relative;
    top: 2px
}
/* 定义过渡效果 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
.ragTag,.ragTagSearch {
		margin: 0 1px;
		padding: 0px;
		position: relative;
		cursor: pointer;
		user-select: none;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 10px;
		font-weight: 400;
		bottom: -2px;
		margin: 0px;
		text-decoration-color: transparent;
		color: #181b49;
		background-color: #F0F1F9;
		border-radius: 8px;
		height: 16px;
		width: 16px;
		// padding: 0 4px;
		svg{
			pointer-events: none;
			width: 16px;
			height: 16px;
			
			path{
				fill: #9A99AA;
			}
		}
	}

	.ragTag.active,.ragTagSearch:hover {
		// background-color: #355eff;
		// color: #fff;
		path{
				fill: #000;
			}
	}
.text-black {
	
	
	.footer {
		// border-top: 1px solid rgba(0, 0, 0, 0.1);
		padding-top: 0px;
		position: relative;
		.learn-more {
			flex: 0 0 auto;
			display: inline-block;
			// min-width: 35px;
			padding-top: 2px;
			font-size: var(--font14);
			color: #646479;
			margin-top: 12px;
			margin-right: 3px;
		}
		&::before {
			content: '';
			width: calc(100% - 32px);
			height: 1px;
			background-color: rgba(0, 0, 0, 0.1);
			position: absolute;
			margin-bottom: 20px;
		}
	}
	.attribution-container {
		flex: 1;
		padding-top: 2px;
		max-width: calc(100% - 38px);
		.attribution-items-link {
			margin-top: 8px;
			a {
				display: block;
			}
			.pdfLink,
			.spanLink {
				margin: 0;
				display: flex;
				align-items: center;
				font-size: var(--font14);
				vertical-align: top;
				.fileIcon {
					margin-right: 4px;
				}
			}
			span {
				color: #646479;
			}
			a,
			span,
			.spanLink {
				min-width: var(--font20);
				font-weight: 400;
				cursor: pointer;
				font-size: 14px;
				color: #646479;
			}
			a,
			.spanLink {
				@extend %attribution-item-link;
			}
			.fileName {
				background: none;
			}
		}
		.attribution-items {
			margin-top: 8px;
			display: flex;
			align-items: center;
			gap: 8px;
			flex-wrap: wrap;
			.pdfLink,
			.spanLink {
				margin: 0;
				display: flex;
				align-items: center;
				font-size: var(--font14);
				vertical-align: top;
				.fileIcon {
					margin-right: 4px;
				}
			}
			span {
				color: #646479;
			}
			a,
			span,
			.spanLink {
				min-width: var(--font20);
				font-weight: 400;
				cursor: pointer;
				font-size: 14px;
				color: #646479;
			}
			a,
			.spanLink {
				@extend %attribution-item;
			}
			.fileName {
				background: none;
			}
		}
	}
	.whitespace-annex-box {
		// max-width: 700px;
		margin-bottom: 4px;
		text-align: justify;
		text-align-last: left;
	}
	.textBorder {
		border-top: 1px solid #ffffff;
		padding-top: 4px;
	}
	.attribution-items-file {
		background-color: rgba(53, 94, 255, 0.1);
		border-radius: 8px;
		cursor: pointer;
	}
}
.text-message-reply-nopadding{
	// padding: 0 !important;
	padding: 4px !important;
	> div {
		padding: 0 !important;
	}
} 
.text-message-reply {
	background: rgba(255, 255, 255, 0) !important;
	padding: 0 !important;
	overflow: hidden;
	> div {
		width: 100%;
		padding: 8px 1rem;
		background-color: rgba(255, 255, 255, 1);
		box-sizing: border-box;
		text-align: justify;
	}
	> .btns {
		margin-top: 0 !important;
		// border-radius: 0 0 1rem 1rem;
	}
	.question {
		background: none !important;
		// border: none !important;
		padding: 0 !important;
	}
}
.maxHeight260 {
	max-height: 260px;
	overflow: auto;
}
.isImgCss {
	color: #181b49 !important;
	background: rgba(53, 94, 255, 0.06) !important;
	img {
		margin-bottom: 10px;
		border-radius: 8px;
		background: #d8d8d8;
		border: 2px solid #ffffff;
		max-width: 400px;
	}
}
// .recommend-container {
// 	position: relative;
// }

.recommend-popup {
	font-size: var(--font12);
	color: #646479;
	display: flex;
	align-items: center;
	// padding-bottom: 12px;
	.about {
		margin: 0 6px 0 18px;
	}
}
.recommend-hot {
	display: flex;
	float: right;
	font-size: var(--font14);
	align-items: center;
	svg {
		width: 16px;
		height: 16px;
		margin-right: 3px;
	}
}
.recommend-title {
	display: block;
	font-size: var(--font14);
	color: #181b49;
	margin-bottom: 5px;
	.number {
		margin-right: 7px;
		font-weight: 500;
	}
	.recommend-index-1{
		color: #F54B5B;
	}
	.recommend-index-2{
		color: #F29222;
	}
	.recommend-index-3{
		color: #355EFF;
	}
}
.recommend-title-pointer {
	cursor: pointer;
}
.recommend-item {
	display: flex;
	align-items: center;
	height: 22px;
	border-radius: 12px;
	font-size: var(--font12);
	color: #355eff !important;
	padding: 0 8px;
	margin: 0 4px;
	background-color: transparent;
	border: 1px solid #355eff !important;
	svg {
		width: 12px;
		height: 12px;
		margin-top: -2px;
		margin-right: 3px;
	}
	&:hover {
		color: #fff !important;
		background: #355eff !important;
		svg {
			path[data-follow-fill] {
				fill: #fff;
			}
		}
	}
}

.text-no-wrap {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	font-size: var(--font14);
	background: rgba(245, 248, 255, 0.1);
	border-radius: 8px;
	padding: 3px 6px;
	width: fit-content;
	.cool-icon {
		font-size: var(--font14);
		margin-right: 3px;
		vertical-align: text-bottom;
	}
}
.text-no-a {
	word-break: break-all;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	font-size: var(--font14);
	background: rgba(245, 248, 255, 0.1);
	border-radius: 8px;
	padding: 3px 6px;
	.cool-icon {
		font-size: var(--font14);
		margin-right: 3px;
		vertical-align: text-bottom;
	}
}
.yinyong-modal {
	width: 60% !important;
	margin: 40px 0 !important;
	padding: 24px 50px !important;
	.w-modal-title {
		font-size: var(--font20);
	}
	.w-modal-body {
		font-size: var(--font16);
		text-indent: 2rem;
	}
}
.modelType {
	color: #181b49;
	margin-left: 3px;
	font-size: var(--font14);
	font-weight: bold;
}
.dot-aniNew {
	display: inline-block;
	height: 16px;
	line-height: 16px;
	overflow: hidden;
}
.dot-aniNew::after {
	font-size: 16px;
	display: inline-block;
	white-space: pre;
	content: '\A.\A..\A...\A....\A.....\A......';
	animation: spin 2s steps(6) infinite;
}
@keyframes spin {
	to {
		-webkit-transform: translateY(-96px);
		transform: translateY(-96px);
	}
}
@keyframes spinImg {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
.loading-message{
	display:flex;
	align-items:center;
	font-size:var(--font16);
	color:#181b49;
}
.loading-text {
	background: #f4f6f9;
	border-radius: 8px;
	padding-left: 8px;
}
.loading-img {
	    display: flex;
		align-items: center;
		justify-content: center;
		transform-origin: center center;
        animation: spinImg 1s linear infinite;
        will-change: transform;
		margin-right: 3px;
}
// .recommend-box {
// 	cursor: pointer;
// }
// .recommend-popup {
// 	display: none;
// 	transition: all 1s easy;
// }

/* 默认显示第一个 .box 下的 .list2 */
// .recommend-box:first-of-type .recommend-popup {
// 	display: flex;
// }
// .recommend-box:first-child .recommend-title {
// 	margin-bottom: 0px;
// }
// .recommend-box:nth-child(2) .recommend-title span {
// 	color: #f54b5b;
// }
// .recommend-box:nth-child(3) .recommend-title span {
// 	color: #f29222;
// }
// .recommend-box:nth-child(4) .recommend-title span {
// 	color: #355eff;
// }
</style>
<style>
.toc-content ul {
	list-style: none;
	padding-left: 0;
	margin: 0;
}

.toc-content li {
	margin: 6px 0;
	line-height: 1.4;
}

.toc-content a {
	color: #646a73;
	text-decoration: none;
	display: block;
	padding: 2px 12px;
	border-radius: 4px;
	transition: all 0.2s;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.toc-content ul ul {
	padding-left: 8px;
}

.toc-content a:hover {
	color: #1f48c8;
}

.toc-content a.active,
.toc-content li.active > a {
	color: #1f48c8;
	font-weight: bold;
}
.toc-content {
	width: 260px;
	height: 100vh;
	padding: 0;
	background: var(--color-bg-2);
}
.markdown-toc {
	height: calc(100vh - 67px);
	overflow-y: scroll;
}

a.header-anchor {
	display: none !important;
}
</style>